export default __webpack_public_path__ + "static/media/polymeric_shinpad_sizes.f6c2cf3c.jpg";